module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list_nav_wrap"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "clearfix findall",
    attrs: {
      "click_type": "sale-brands"
    }
  }, _vm._l((_vm.list), function(item) {
    return _c('li', [_c('a', {
      class: {
        'listNav_active': _vm.active === item.brand
      },
      attrs: {
        "click_type": "list-nav-brand-dazhong"
      },
      on: {
        "click": function($event) {
          _vm.doSelect(item.brand)
        }
      }
    }, [_vm._v("\n                " + _vm._s(item.brandName) + "\n            ")])])
  })), _vm._v(" "), _c('div', {
    staticClass: "list_allBrand clearfix",
    staticStyle: {
      "display": "none",
      "width": "0px"
    },
    attrs: {
      "click_type": "sale-all-brands"
    }
  }, [_c('p', [_vm._v("所有品牌")]), _vm._v(" "), _c('div', {
    staticClass: "list_allBrand_wrap"
  }, [_c('div', {
    staticClass: "allBrand_contain"
  }, _vm._l((_vm.listMoreByLetter), function(groupValue, groupName) {
    return _c('dl', {
      staticClass: "clearfix"
    }, [_c('dt', [_vm._v(_vm._s(groupName))]), _vm._v(" "), _c('dd', _vm._l((groupValue), function(item) {
      return _c('a', {
        on: {
          "click": function($event) {
            _vm.doSelect(item.code)
          }
        }
      }, [_vm._v("\n                            " + _vm._s(item.name) + "\n                        ")])
    }))])
  }))])]), _vm._v(" "), _c('span', {
    staticClass: "cover"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "list_nav_title clearfix"
  }, [_c('label', [_vm._v("品牌")]), _c('a', {
    staticClass: "nav_list_more",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("更多 » ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2103cd7f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components-buy/ListContain/NavContainer/ListNav/NavBrand.vue
// module id = 841
// module chunks = 5